/* src/app/modules/print-cards/components/cards/backgrounds/index-cards-3x5/koan-index-card-stack-background/koan-index-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
  background-color: #ece9e3;
}
/*# sourceMappingURL=koan-index-card-stack-background.component.css.map */
